import React from 'react';
import { useState, useContext } from 'react';
import api_request from '../../../../lib/connection';
import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

import FormState from '../../../../Components/UI/Form/FormState';
import FormUtils from '../../../../Components/UI/Form/FormUtils';
import Button from '../../../../Components/UI/Button/Button';
import Modal from '../../../../Components/UI/Modal/Modal';
import DataDisplay from './DataDisplay';
import keyValueStore from '../../lib/keyValueStore';
// import { formActions } from '../../../../Components/UI/Form/store/forms-reducer';
// import { imageActions } from "../../store/image";

const testPromise = () => {
  return new Promise( (resolve, reject) => {
    resolve( {message: 'ok', status: '666' }); // => Network error
    //reject( {message: 'Shit hapend', response: { data: { message: 'DO YOU SEE THE LIGHT?' }}} ) // response
    //reject( {message: 'Shit hapend', request: 'foo' } ) // no response, but request -> No response from server
    //reject(new Error("Something' wrong"));  // no response, no request -> yield 'request error'
  }) 
};

const apiEndpoint = '/gmapp';

const SendData = (props) => {
  const [msg, setMsg] = useState( null );
  const [errorMsg, setErrorMsg] = useState( null );
  const store = useSelector( state => state );
  const dispatch = useDispatch();
//  const navigate = useNavigate();

  const aim = keyValueStore.search( 'aim' );
  const birthdate = keyValueStore.search( 'birthdate' );
  const formId = keyValueStore.search( 'formId' );
  //const formNeeded = formId && formId.startsWith("U");

  // @TODO: get formIdNum from config
  const formMapping = {
    "-": 1,
    "U7": 2,
    "U7a": 3
  };
  const formIdNum = formMapping[formId] || 0;

  // #@TODO: Check if this works
  // const formIdNum = configData.forms.find(form => form.id === formId)?.number || 0;

  //const valid =  (!formNeeded || store.forms.forms.U?.isValid) &&
  const valid =  (store.forms.forms.U?.isValid || formIdNum == 1) &&
                 store.forms.forms.consent?.isValid &&
                 !!store.forms.forms.consent?.state.sig_img.value &&
                 aim != null &&
                 store.img.img;

  let data = null;
  if (valid) {
    //const udata = formNeeded ? FormUtils.simpleFormExtractor( store.forms.forms.U ) : {};
    const udata = FormUtils.simpleFormExtractor( store.forms.forms.U );
    const consentdata = FormUtils.extractValuesFromStore( store.forms.forms.consent );
    data = {
              exam: { 
                ...consentdata, 
                application_ident: store.config.data.config.appId,
                gmapp_form_id: formIdNum, 
                gmapp_text_id: store.config.data.config.infoTextId,
                birthdate: birthdate,
                age_in_month: aim,
                answers: udata,
                physician: `${consentdata.physician_name}, ${consentdata.physician_location}`,
                patient_image_base64: store.img.img
              },
              config: store.config.data.config,

           };
  }
  console.log( data );

  const sendDataHandler = async () => {
    api_request(
      apiEndpoint,
      'post',
      data,
      {},
      { 
        'Accept': 'application/json',
        'enctype': 'multipart/form-data' 
      }
    )
    .then( () => setMsg('Die Daten wurden erfolgreich übertragen. Sobald die Analyse abgeschlossen ist, werden Sie per E-Mail darüber informiert.') )
    .catch( (err) => setErrorMsg( err.message ) );
  }
  
  const modalClosedHandler = () => {
    setMsg(null);
    setErrorMsg(null);
    // navigate('/submit');
  }

  const configData = useSelector(state => state.config.data);

  return <>
    { msg && 
      <Modal show={!!msg}
        modalClosed={ modalClosedHandler }
        className = 'success'>
          <div>{msg}</div>
      </Modal>
    }
    { errorMsg && 
      <Modal show={!!errorMsg}
        modalClosed={() => { setErrorMsg(null) }}
        className = 'error'>
          <div>{errorMsg}</div>
      </Modal>
    }
    { !(store.img.img) && 
          <div style={{margin: "20px 0"}}>
          <span style={{color: "red"}}>
            Bitte fügen Sie ein Foto hinzu.<br />
          </span>
        </div>
    }
    <p>
      Geburtsdatum: {birthdate ? Intl.DateTimeFormat('de').format(new Date(birthdate)) : 'Bitte angeben!'}<br />
      Alter in Monaten: {aim}<br />
      Fragebogen: {formId}
    </p>
    <FormState label='U' 
               fallbackMessage = 'Bitte den Reiter "Fragebogen" ausfüllen.' />
    <FormState label='consent' 
               fallbackMessage = 'Bitte den Reiter "Einverst." ausfüllen.' />
    <br />
    {valid && 
      <div style={{margin: "20px 0"}}>
        <span style={{color: "#CE5328e"}}>
          Bitte überprüfen Sie Ihre Eingaben und reichen Sie Ihre Daten ein, indem Sie unten auf "Daten senden" klicken.<br />
        </span>
        <DataDisplay data={data.exam} hasImage={store.img.img} />
      </div>
    }
    <Button onClick={sendDataHandler}
            disabled={!valid}
    >
      Daten senden
    </Button>
  </>
}


export default SendData;

/*
      <div>
        { sig && (<img style={{width:'100px'}} src={"data:image/svg+xml;base64," + sig} />) }
      </div>
*/